<template>
  <!--自定义红黑榜身份显示-->
  <div>
    {{redRole ? redRole : ''}}
  </div>
</template>

<script>
export default {
  data () {
    return {
      redRole: null
    }
  },
  props: {
    record: Object, // 当前行的数据
    options: Array,
    vm: null, // 使用这个action的模型组件，可能为modelTable或modelTree，与callback中的vm用法保持一致
    title: String,
    modal: String
  },
  mounted () {
    this.getInit()
  },
  methods: {
    async getInit () {
      if (!this.record.redRole) { return }
      this.redRole = this.record.redRole === 'woker' || this.record.redRole === 'stylist' ? '个人' : '公司'
    }
  }
}
</script>

<style lang="less" scoped>
</style>
